import './index.css'

import React from 'react'
import { connect } from 'react-redux'
import type { Location } from 'react-router-dom'

import mixpanel from '@disco/api/mixpanel'
import { getLocationBeforeTransitions } from '@disco/state-management/selectors/routing'

import type { State } from 'types/redux'
import type { Shortlist as ShortlistType } from 'types/shortlist'

import Button from 'components/ui/button'

const MAX_LENGTH_NAME_SECTION = 255

type Props = {
  shortlist: ShortlistType
  activeUploads: boolean
  location: Location
}

const mapStateToProps = (state: State) => ({
  location: getLocationBeforeTransitions(state),
})

class Save extends React.Component<Props> {
  _renderDisabled(): React.ReactNode {
    return <Button caption="Save" compact disabled />
  }

  render(): React.ReactNode | React.ReactElement<'button'> {
    if (this.props.shortlist.items.length === 0) {
      return this._renderDisabled()
    }

    const containNotProcessedTracks =
      this.props.shortlist.items.filter(item => !item.track.uploaded).length > 0
    const containInvalidSection = this.props.shortlist.sections.find(
      s => s.name.length > MAX_LENGTH_NAME_SECTION,
    )

    if (
      this.props.activeUploads ||
      containNotProcessedTracks ||
      containInvalidSection
    ) {
      return this._renderDisabled()
    }

    const { id } = this.props.shortlist
    const { location } = this.props

    // Use search-nested route if we're on a search page
    const isOnSearchPage = location?.pathname?.startsWith('/search')
    const returnPath = isOnSearchPage
      ? location.pathname + (location.search || '')
      : '/'

    const saveLocation = {
      pathname: isOnSearchPage
        ? `/search/shortlists/${id}/save`
        : `/shortlists/${id}/save`,
      state: {
        returnPath,
      },
    }

    return (
      <Button
        link={saveLocation}
        caption="Save"
        compact
        onClick={() => {
          mixpanel.sendPureEvent('Playlist Creator - Save playlist')
        }}
      />
    )
  }
}

export default connect(mapStateToProps)(Save)
